module.exports = __webpack_public_path__ + "img/Finland.916fa8c5.png";